import * as StandardEventsLibrary from '@shopify/events';
import { isDesignMode, onReady } from '@theme/standard-events-utils';

const PageViewEvent = StandardEventsLibrary.PageViewEvent;

onReady(function dispatchPageView() {
  if (isDesignMode() || typeof PageViewEvent !== 'function') return;

  try {
    const main = document.querySelector('main[data-template]');

    document.dispatchEvent(
      new PageViewEvent({
        page: {
          template: (main && main.dataset.template) || '',
          title: document.title,
          url: window.location.href,
        },
      })
    );
  } catch (error) {
  }
});
